import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { VehicleTypeDto } from './vehicleTypeDto'
import { VehicleRecallDto } from './vehicleRecallDto'
import { VehicleCheckInDto } from './vehicleCheckInDto'
import { VehicleCheckInDetailsDto } from './vehicleCheckInDetailsDto'
import { VehicleClusterInformationDto } from './vehicleClusterInformationDto'
import { InboundTripPAPSDto } from './inboundTripPAPSDto'
import { BuildABoxBundleDto } from './buildABoxBundleDto'
import { ClusterShipperDto, CompanyAddressDto, OutboundTripDto, VehicleDamageDto, VehicleInvoicingDto } from 'dtos'
import { KG, LB } from 'localConstants'

export class VehicleDto {
  vehicleId?: number = undefined
  vehicleGuid?: string = undefined
  id?: string = undefined
  buyerCompany?: CompanyDto = undefined
  buyerCompanyAddress?: CompanyAddressDto = undefined
  exporterCompany?: CompanyDto = undefined
  exporterCompanyAddress?: CompanyAddressDto = undefined
  importer?: CompanyDto = undefined
  vehicleType?: VehicleTypeDto = undefined
  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  oem?: string = undefined
  odometerReading?: number = undefined
  mfgBuildDateMonth?: number = undefined
  mfgBuildDateYear?: number = undefined
  mfgCity?: string = undefined
  mfgState?: string = undefined
  mfgCountry?: string = undefined
  countryOfOrigin?: string = undefined
  amountUSD?: number = undefined
  vsaCode?: string = undefined
  importerStockNumber?: string = undefined
  isVehicle25OrMoreYearsOld?: boolean = undefined
  isAppendixBVehicle?: boolean = undefined
  weightGVWR?: number = undefined
  weightGVWRUnitOfMeasurement?: string = undefined
  weightGVWRKg?: number = undefined
  weightGVWRLbs?: number = undefined
  weightGAWRFR?: number = undefined
  weightGAWRFRUnitOfMeasurement?: string = undefined
  weightGAWRFRKg?: number = undefined
  weightGAWRFRLbs?: number = undefined
  weightGAWRRR?: number = undefined
  weightGAWRRRUnitOfMeasurement?: string = undefined
  weightGAWRRRKg?: number = undefined
  weightGAWRRRLbs?: number = undefined
  curbWeight?: number = undefined
  frontTires?: string = undefined
  frontRims?: string = undefined
  frontTiresPressure?: number = undefined
  frontTiresPressureUnitOfMeasurement?: string = undefined
  frontTiresPressurekPa?: number = undefined
  frontTiresPressurePSI?: number = undefined
  rearTires?: string = undefined
  rearRims?: string = undefined
  rearTiresPressure?: number = undefined
  rearTiresPressureUnitOfMeasurement?: string = undefined
  rearTiresPressurekPa?: number = undefined
  rearTiresPressurePSI?: number = undefined
  numberOfRearTires?: number = undefined
  rearTireConfig?: string = undefined
  vehicleCheckInRearTireConfig?: string = undefined
  isLocked?: boolean = false
  canBeLocked?: boolean = false
  isCancelled?: boolean = false
  cancelledDateTime?: string = undefined
  isArchived?: boolean = false
  archivedDateTime?: string = undefined
  parkingSpace?: string = undefined
  createdDateTime?: string = undefined
  sentToBrokerDateTime?: string = undefined
  vehicleCheckInDateTime?: string = undefined
  michiganTitleApplicationPacketReadyForMISoSBundleDateTime?: string = undefined
  rejectionDateTime?: string = undefined
  clusterPulledDateTime?: string = undefined
  submittedToDotDateTime?: string = undefined
  readyForOutboundDateTime?: string = undefined
  vehicleReleaseDateTime?: string = undefined
  bondReleaseDateTime?: string = undefined
  dropOffDate?: string = undefined
  clusterShipperNumber?: string = undefined
  clusterConversionCompletedDate?: string = undefined
  clusterDeliveredToThirdPartyAdditionalProgrammingCompanyDate?: string = undefined
  manufacturerLabelOrdered?: string = undefined
  manufacturerLabelReceived?: string = undefined
  tirePressureLabelOrdered?: string = undefined
  tirePressureLabelReceived?: string = undefined
  applicationPacketReadyToPrintDateTime?: string = undefined
  applicationPacketReadyForBuildABoxDateTime?: string = undefined
  applicationPacketReadyForMiSosBundleDateTime?: string = undefined
  vehicleCheckInDetails?: VehicleCheckInDetailsDto = undefined
  vehicleCheckInOdometerReadingInKillometers?: number = undefined
  vehicleCheckInOdometerReadingInMiles?: number = undefined
  // vehicleCheckInOdometerReadingMileage?: number = undefined
  vehicleCheckInOdometerUnitOfMeasurement?: string = undefined
  convertCluster?: boolean = false
  programCluster?: boolean = false
  vehicleCheckInBondNumber?: string = undefined
  vehicleCheckInMfgBuildDateMonth?: number = undefined
  vehicleCheckInMfgBuildDateYear?: number = undefined
  vehicleCheckInParkingSpace?: string = undefined
  vehicleCheckInWeightGVWR?: number = undefined
  vehicleCheckInWeightGVWRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGAWRFR?: number = undefined
  vehicleCheckInWeightGAWRFRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGAWRRR?: number = undefined
  vehicleCheckInWeightGAWRRRUnitOfMeasurement?: string = undefined
  vehicleCheckInFrontTires?: string = undefined
  vehicleCheckInFrontRims?: string = undefined
  vehicleCheckInFrontTiresPressure?: number = undefined
  vehicleCheckInFrontTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInRearTires?: string = undefined
  vehicleCheckInRearRims?: string = undefined
  vehicleCheckInRearTiresPressure?: number = undefined
  vehicleCheckInRearTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInNumberOfRearTires?: number = undefined
  importerNotes?: string = undefined
  clusterInformation?: VehicleClusterInformationDto = undefined
  clusterConversionInHouseOrThirdParty?: string = undefined
  clusterConversionStartedInHouseDate?: string = undefined
  clusterRemovalStartDate?: string = undefined
  clusterReinstallationCompletedDate?: string = undefined
  currentOdometerReadingAfterClusterReinstallationComplete?: number = undefined
  clusterConversionStarted?: boolean = false
  clusterConversionInHouseStarted?: boolean = false
  thirdPartyClusterConversionCompanyId?: number = undefined
  additionalProgramming?: boolean = false
  additionalProgrammingCompletedDate?: string = undefined
  additionalProgrammingInHouseOrThirdParty?: string = undefined
  additionalProgrammingStarted?: boolean = false
  additionalProgrammingInHouseStarted?: boolean = false
  thirdPartyAdditionalProgrammingCompanyId?: number = undefined
  needsIncorrectMileageResolutionDate?: string = undefined
  inboundTripPAPS?: InboundTripPAPSDto = undefined
  outboundTrip?: OutboundTripDto = undefined
  buildABoxBundle?: BuildABoxBundleDto = undefined
  clusterShipper?: ClusterShipperDto = undefined
  ownerCompany?: CompanyDto = undefined
  michiganTitleApplicationReceiptUploadedDateTime?: string = undefined
  michiganTitleRegisteredImporterWillNotReceiveTitle?: boolean = undefined
  titleApplicationDeliveryPhotoUploadedDateTime?: string = undefined

  titleUploadedDateTime?: string = undefined
  michiganTitleOdometer?: number = undefined
  ohioTitleOdometer?: number = undefined
  signedBOLDateTime?: string = undefined
  titleDestinationCompany?: CompanyDto = undefined
  vehicleDestinationCompany?: CompanyDto = undefined
  _7501DocumentGuid?: string = undefined
  _7501DocumentFileName?: string = undefined
  canOwnershipGuid?: string = undefined
  canOwnershipFileName?: string = undefined
  isCheckedIn?: boolean = undefined
  isInClusterConversionShipper?: boolean = undefined
  isInOutboundTrip?: boolean = undefined

  vehicleDamage?: VehicleDamageDto = undefined
  warrantyCertPhotoFileName?: string = undefined
  dotRejectionDate?: string = undefined
  conformityPackageTrackingNumber?: string = undefined
  conformityZipPreview?: string = undefined
  conformityZipDownload?: string = undefined
  sentToDOTDate?: string = undefined

  rejectionLetterFileName?: string = undefined

  // I do not know what these are here for. MJS 5/20/2024
  vehicleStatus?: string = undefined
  vehicleDestination?: string = undefined
  transporter?: CompanyDto = undefined
  vehicleRecalls?: VehicleRecallDto[] = undefined
  vehicleCheckIn?: VehicleCheckInDto = undefined
  inactive?: boolean = false

  vehicleInvoicing?: VehicleInvoicingDto = undefined
  readyToInvoiceDate?: string = undefined
  sentToQuickBooksDate?: string = undefined
  qbInvoiceNumber?: string = undefined
  isInInvoicingServices?: boolean = false
}

export const vehicleValidationSchema = yup.object<VehicleDto>({
  vehicleGuid: yup.string().nullable(),
  exporterCompany: yup.object().required('Exporter is required'),
  vehicleType: yup.object().required('Vehicle Type is required.'),
  vin: yup.string().min(17, 'VIN must be 17 characters.').max(17, 'VIN must be 17 characters.').required('VIN is required.'),
  year: yup.number().min(1954, 'Year cannot be less than 1954.').max(2100, 'Year cannot be more than 2100.').required('Year is required.'),
  make: yup.string().max(200, 'Make cannot be more than 200 characters.').required('Make is required.'),
  model: yup.string().max(200, 'Model cannot be more than 200 characters.').required('Model is required.'),
  oem: yup.string().max(200, 'OEM cannot be more than 200 characters.').required('OEM is required.'),
  mfgBuildDateMonth: yup
    .number()
    .min(1, 'MFG Build Date (Month) must be between 1 and 12.')
    .max(12, 'MFG Build Date (Month) must be between 1 and 12.')
    .required('MFG Buld Date (Month) is required.'),
  mfgBuildDateYear: yup
    .number()
    .min(1000, 'MFG Buld Date (Year) cannot be less than 1000.')
    .max(3000, 'MFG Buld Date (Year) cannot be more than 3000.')
    .required('MFG Buld Date (Year) is required.'),
  mfgCity: yup.string().max(200, 'MFG City cannot be more than 200 characters.').nullable(),
  mfgState: yup.string().max(200, 'MFG State cannot be more than 200 characters.').nullable(),
  mfgCountry: yup.string().max(200, 'MFG Country cannot be more than 200 characters.').nullable(),
  amountUSD: yup
    .number()
    .typeError('Amount (USD) cannot be less than $0.00.')
    .min(0.0, 'Amount (USD) cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Amount (USD) cannot be more than $999,999,999,999,999.99.')
    .nullable(),
  weightGVWR: yup
    .number()
    .typeError('Weight GVWR is required.')
    .min(0.0, 'Weight GVWR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GVWR cannot be more than 999,999,999,999,999.99.')
    .required('Weight GVWR is required.'),
  weightGVWRUnitOfMeasurement: yup
    .string()
    .oneOf([KG, LB], 'Weight GVWR Unit of Measurement must be Kg or Lb.')
    .required('Weight GVWR Unit of Measurement is required.'),
  weightGAWRFR: yup
    .number()
    .min(0.0, 'Weight GAWR FR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GAWR FR cannot be more than 999,999,999,999,999.99.')
    .nullable(),
  weightGAWRRR: yup
    .number()
    .min(0.0, 'Weight GAWR RR cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Weight GAWR RR cannot be more than 999,999,999,999,999.99.')
    .nullable(),
  frontTires: yup.string().max(200, 'Front Tires cannot be more than 200 characters.').nullable(),
  frontRims: yup.string().max(200, 'Front Rims cannot be more than 200 characters.').nullable(),
  frontTiresPressure: yup
    .number()
    .min(0.0, 'Front Tire Pressure cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Front Tire Pressure cannot be more than 999,999,999,999,999.99.')
    .nullable(),
  frontTiresPressureUnitOfMeasurement: yup.string().nullable(),
  rearTires: yup.string().max(200, 'Rear Tires cannot be more than 200 characters.').nullable(),
  rearRims: yup.string().max(200, 'Rear Rims cannot be more than 200 characters.').nullable(),
  rearTiresPressure: yup
    .number()
    .min(0.0, 'Rear Tire Pressure cannot be less than 0.00.')
    .max(999_999_999_999_999.99, 'Rear Tire Pressure cannot be more than 999,999,999,999,999.99.')
    .nullable(),
  rearTiresPressureUnitOfMeasurement: yup.string().nullable(),
  numberOfRearTires: yup
    .number()
    .min(0.0, 'Number of Rear Tires cannot be less than 0.00.')
    .max(999_999_999, 'Number of Rear Tires cannot be more than 999,999,999.')
    .nullable()
})
